import { ThemeProjectNeritClin } from 'submodules/neritclin-components-ui/theme/project/white-labels/ThemeProjectNeritClin'
import { ThemeProjectLisoLaser } from 'submodules/neritclin-components-ui/theme/project/white-labels/ThemeProjectLisoLaser'

const domain = window.location.pathname.split('/')[1];
const isLisoLaser = domain === 'lisolaser'

export const ThemeProject = isLisoLaser ? ThemeProjectLisoLaser : ThemeProjectNeritClin;
